<template>
  <div>
    <section class="footer-help">
      <h3 class="mb-5">{{$t('footer.help.title')}}</h3>
      <el-row :type="rowType" justify="center" class="jp-column">
        <el-col :span="8" :xs="24" class="help-col">
          <div class="d-flex align-top help-text">
            <img :src="comments" class="mt-2" />
            <div class="help-content ml-3">
              <h5>{{$t('footer.help.question')}}</h5>
              <p class="my-3">{{$t('footer.help.answers')}}</p>
              <a class="contact-now" @click="setActiveNav(6, 'contactUs')">
                <i class="el-icon-arrow-right"></i>
                {{$t('footer.help.contactNow')}}
              </a>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24" class="phone-conact help-col">
          <div class="d-flex align-top help-text">
            <img :src="phone" class="mt-2" />
            <div class="help-content ml-3">
              <h5>{{$t('footer.help.contactUs')}}</h5>
              <!-- <p class="my-3">{{$t('footer.help.process')}}</p> -->

              <div class="d-flex mt-3">
                <label>{{$t('footer.help.tel')}}</label>
                <a href="tel:03-57192660">
                  <!-- <i class="el-icon-arrow-right"></i> -->
                  03-5220-8899
                </a>
              </div>
              <!-- <div class="d-flex">
                <label>{{$t('footer.help.fax')}}</label>
                <a>
                  03-5220-8899
                </a>
              </div> -->
              <div class="d-flex">
                <label>{{$t('footer.help.eMail')}}</label>
                <a href="mailto:admin@cncec-jri.com">
                  <!-- <i class="el-icon-arrow-right"></i> -->
                  admin@cncec-jri.com
                </a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </section>
    <div class="footer">
      <div class="jp-column  mb-3">
        <div class="text-left footer-router">
          <i class="el-icon-s-home jp-pointer" @click="goHome"></i>
          <i class="el-icon-arrow-right ml-2"></i>
          <span class="route-title">{{routeName}}</span>
        </div>
        
        <el-row>
          <el-col :span="5">
            <div class="footer-nav">
              <h4>{{$t('about.title')}}</h4>
              <!-- <a @click="setActiveNav(0, 'about', 'first')">{{$t('about.name3')}}</a> -->
              <a @click="setActiveNav(1, 'about', 'first')">{{$t('about.name1')}}</a>
              <!-- <a @click="setActiveNav(0, 'about', 'third')">{{$t('about.name2')}}</a> -->
              <!-- <a @click="setActiveNav(1, 'about', 'fifth')">{{$t('about.name4')}}</a> -->
            </div>
          </el-col>
          <el-col :span="8">
            <div class="footer-nav">
              <h4>{{$t('acti.title')}}</h4>
              <a @click="setActiveNav(2, 'acti')">{{$t('acti.businessName1')}}</a>
              <a @click="setActiveNav(2, 'acti')">{{$t('acti.businessName2')}}</a>
              <a @click="setActiveNav(2, 'acti')">{{$t('acti.businessName3')}}</a>
              <a @click="setActiveNav(2, 'acti')">{{$t('acti.businessName4')}}</a>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="footer-nav">
              <h4>{{$t('menu.recruit')}}</h4>
              <a @click="setActiveNav(3, 'recruit')">{{$t('recruit.title')}}</a>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="footer-nav">
              <h4>{{$t('news.title')}}</h4>
              <a @click="setActiveNav(4, 'newsList')">{{$t('news.newsRelease')}}</a>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="jp-column hidden-xs-only">
        <div class="copy-right d-flex">
          <div class="text-left">Copyright: 2022 The CNCEC. All Rights Reserved</div>
          <div class="privacy-policy" @click="openPrivacyPolicy"><a>{{$t('footer.privacyPolicy')}}</a></div>
        </div>
      </div>
      <div class="jp-column hidden-sm-and-up">
        <div class="footer-mobile">
          <div class="text-left">Copyright: 2022 The CNCEC. All Rights Reserved</div>
          <div class="text-left" @click="openPrivacyPolicy"><a>{{$t('footer.privacyPolicy')}}</a></div>
          <!-- <div class="link">
            {{$t('footer.help.links')}}
            <a style="color: #fff" href="https://www.china-richem.com/">https://www.china-richem.com/</a>
          </div> -->
        </div>
      </div>
    </div>
    <privacy-policy-modal :isOpen="dialogVisible" @modalClose="handleClose"></privacy-policy-modal>
  </div>
</template>

<script>
import comments from '@/assets/img/control-comments.svg';
import phone from '@/assets/img/control-phone.svg';
import privacyPolicyModal from '@/components/privacy-policy-modal';
export default {
  name: 'jpFooter',
  data () {
    return {
      dialogVisible: false,
      rowType: '',
      modalWidth: '80%',
      routeName: this.$t('menu.home'),
      comments: comments,
      phone: phone
    }
  },
  components: {
    privacyPolicyModal
  },
  watch: {
    $route(route) {
      this.routeName = this.$t('menu.' + route.name);
    },
    '$i18n.locale'(val) {
      this.routeName = this.$t('menu.' + this.$route.name);
    }
  },
  created() {
    this.routeName = this.$t('menu.' + this.$route.name);
    this.getWidth();
  },
  methods: {
    setActiveNav (index, path, param) {
      this.$router.push({ name: path, params: { type: param }, query: { route: index } })
    },
    openPrivacyPolicy() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
        this.alignType = ''
        this.modalWidth = '95%'
      } else {
        this.rowType = 'flex'
        this.alignType = 'bottom'
        this.modalWidth = '80%'
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/style/variables.scss';

.footer {
  height: 100%;
  background-color: $footer;
  font-size: 1.3rem;
  color: #e6e8eb;
  padding-top: 2rem;
  .el-col-3 {
    text-align: left;
  }
  .privacy-policy {
    margin-left: 30px;
    cursor: pointer;
    a {
      color: #e6e8eb;
    }
  }
  a {
    cursor: pointer;
    color: $blue;
  }
  .jp-mobile-footer-menu {
    background-color: rgba(45, 77, 158, .95);
    position: absolute;
    z-index: 101;
    width: 100%;
    left: 0;
    color: $black;
    text-align: left;
    font-size: 1.5rem;
    line-height: 42px;
    transition: height 0.5s;
    .jp-mobile-footer-menu-text {
      padding: 1rem;

      .jp-mobile-line {
        border-bottom: 1px solid #9cabd1;
      }
    }
  }
  .footer-router {
    border-bottom: 2px solid #3b4b61;
    padding-bottom: 0.5rem;
    .route-title {
      padding-left: 12px;
      font-size: 14px;
    }
  }
  .footer-nav {
    text-align: left;
    h4 {
      margin: 1rem 0;
    }
    a {
      display: block;
      color: $white;
      font-size: 0.9rem;
      line-height: 28px;
    }
  }
  .footer-mobile {
    a {
      color: $white;
    }
  }
  .copy-right {
    padding: 20px 0;
    font-size: 14px;
    border-top: 2px solid #3b4b61;
    // background-color: #26364d;
    .link {
      font-size: 12px;
    }
  }
}

.footer-help {
  color: #2c2c2c;
  background-image: url('../assets/img/footer-help.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .phone-conact {
    margin-left: 6rem;
  }
  .help-col {
    width: 300px;
  }
  h3 {
    font-size: 2.2rem;
    color: #2c2c2c;
  }
  .help-text {
    text-align: left;
    i {
      font-size: 38px;
      color: #7ab2ea;
    }
    h5 {
      margin: 0;
      font-size: 20px;
    }
    .help-content {
      h5 {
        font-size: 1.5rem;
      }
      p {
        font-size: 1.3rem;
      }
      a {
        color: #2d4854;
        font-size: 1.1rem;
        cursor: pointer;
        width: 230px;
        &.contact-now {
          margin-left: 0;
        }
      }
      label {
        font-size: 1.1rem;
        width: 70px;
      }
      i {
        font-size: 14px;
        background-color: #fff;
        color: #50849c;
      }
    }
  }
}

@media (max-width: 768px) {
  .footer {
    line-height: 35px;
    .copy-right {
      font-size: 12px;
      padding: 20px 0 20px 0;
    }
    .footer-nav {
      text-align: center;
      h4 {
        font-size: 14px;
        line-height: 12px;
      }
    }
    .copy-right {
      .link {
        text-align: left;
      }
    }
  }
  .footer-help {
    .phone-conact {
      margin-left: 0;
      margin-top: 1rem;
    }
    .help-text {
      img {
        width: 30px;
      }
      .help-content {
        p {
          font-size: 14px;
        }
        a {
          font-size: 12px;
        }
        i {
          font-size: 12px;
        }
      }
    }
  }
}
.privacy-policy-modal {
  p {
    font-size: 1rem;
    text-align: left;
    text-indent: 2em;
    line-height: 30px;
  }
  h4 {
    font-size: 1.1rem;
    text-indent: 2em;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue